import FJConfig from "../../config/FJConfig";
import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  alignment: '',
  bold: false,
  italic: false,
  textColor1: FJConfig.mainColor,
  textColor2: FJConfig.subColor,
  textData: [[]],
  textLength: 1,
  colorLength: 1,
  focusIndex: 0,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_TEXT_ANIMATION_FOCUS_INDEX:
      return  {
        ...state,
        focusIndex: action.focusIndex,
      }
    case FJActionConstant.UPDATE_TEXT_ANIMATION_TOOLBAR:
      return  {
        ...state,
      }
    case FJActionConstant.SET_TEXT_ANIMATION_CONTENT:
      return  {
        ...state,
        textData: action.textData,
      }
    case FJActionConstant.SET_TEXT_ANIMATION_ALIGNMENT:
      return {
        ...state,
        alignment: action.alignment
      };
    case FJActionConstant.SET_TEXT_ANIMATION_BOLD:
      return {
        ...state,
        bold: action.data
      };
    case FJActionConstant.SET_TEXT_ANIMATION_ITALIC:
      return {
        ...state,
        italic: action.data
      };
    case FJActionConstant.SET_TEXT_ANIMATION_COLOR_LENGTH:
      return {
        ...state,
        colorLength: action.colorLength
      };
    case FJActionConstant.SET_TEXT_ANIMATION_COLOR:
      return {
        ...state,
        textColor1: action.color1,
        textColor2: action.color2,
      };
    case FJActionConstant.SET_TEXT_ANIMATION_TEXT_LENGTH:
      return {
        ...state,
        textLength: action.textLength
      }
    default:
      return state;
  }
}